// customStyles do react-data-table-component no visual JDS (o escopo
// .jds-scope precisa envolver a tabela para os tokens resolverem).
export const jdsTableStyles = {
  headRow: {
    style: {
      minHeight: 48,
      borderBottomColor: 'var(--border-neutral-subtle)',
    },
  },
  headCells: {
    style: {
      fontSize: 'var(--fs-13)',
      fontWeight: 'var(--fw-medium)',
      color: 'var(--fg-neutral-subtle)',
    },
  },
  rows: {
    style: {
      minHeight: 56,
      fontSize: 'var(--fs-14)',
      color: 'var(--fg-neutral-default)',
      borderBottomColor: 'var(--border-neutral-subtle)',
    },
  },
  cells: {
    style: {
      fontSize: 'var(--fs-14)',
    },
  },
};
